import React from 'react';
import Header from '../components/Header';
import SearchBar from '../components/SearchBar';
import PromoBanner from '../components/PromoBanner';
import Categories from '../components/Categories';
import PopularProducts from '../components/PopularProducts';
import BottomNavigation from '../components/BottomNavigation';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      {/* 固定的顶部导航 */}
      <Header />

      {/* 主要内容区域 */}
      <main className="main-content">
        {/* 搜索栏 */}
        <SearchBar />

        {/* 促销横幅 - Everyday Low Price */}
        <PromoBanner />

        {/* 商品分类 - 可左右滑动 */}
        <Categories />

        {/* 热门商品 */}
        <PopularProducts />
      </main>

      {/* 固定的底部导航 */}
      <BottomNavigation />
    </div>
  );
};

export default HomePage; 